import { render, staticRenderFns } from "./SetTicketSoldTotalQuantity.vue?vue&type=template&id=0c9d66c4"
import script from "./SetTicketSoldTotalQuantity.vue?vue&type=script&lang=js"
export * from "./SetTicketSoldTotalQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports